import { useState, useMemo } from 'react';
import UserMenuDropDown, { UserMenuDropDownProps } from './UserMenuDropDown.component';

type UserMenuDropDownType = Pick<UserMenuDropDownProps, 'username' | 'initials' | 'picture' | 'options'> 

const UserMenuDropDownContainer = function ({ 
  username, 
  initials, 
  picture, 
  options
}: UserMenuDropDownType): JSX.Element {
  const [displayDropDown, setDisplayDropDown] = useState(false);

  const getFirstName = useMemo(() => {
    const [firstName] = (username ?? '').split(' ');
    return firstName;
  }, [username]);

  const handleClickOnUserMenu = (): void => {
    setDisplayDropDown(!displayDropDown);
  };

  return <UserMenuDropDown 
    options={options} 
    username={getFirstName}
    picture={picture}
    initials={initials}
    displayDropDown={displayDropDown}
    handleClickOnUserMenu={handleClickOnUserMenu} 
  />; 
};

export default UserMenuDropDownContainer;
